import Box from '@zenbusiness/zui/Box';
import Divider from '@zenbusiness/zui/Divider';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const BannerWrapperStyle = ({ theme }) => ({
  backgroundColor: theme.palette.common.white
});

const BannerCardStyle = ({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: 24,
  right: 0,
  border: `1px solid ${theme.palette.border.main}`,
  boxShadow: '1px 5px 20px 2px rgba(0, 0, 0, 0.1)'
});

const BannerImageStyle = () => ({
  borderRadius: 16,
  objectFit: 'cover'
});

export const DividerStyled = styled(Divider)(({ theme }) => ({
  height: 1,
  backgroundColor: theme.palette.border.main,
  marginBlock: theme.spacing(2)
}));

const BannerActionStyle = ({ theme }) => ({
  marginTop: theme.spacing(2.5)
});

export const StepNumberStyle = () => ({
  minWidth: '40px',
  height: '40px',
  borderRadius: '50%',
  backgroundColor: '#000'
});

export const BannerWrapper = styled(Stack)(BannerWrapperStyle);
export const BannerCard = styled(Stack)(BannerCardStyle);
export const BannerImage = styled(SharedAsset)(BannerImageStyle);
export const BannerAction = styled(Box)(BannerActionStyle);
export const StepNumber = styled(Stack)(StepNumberStyle);
